import { render, staticRenderFns } from "./myLeaveEdit.vue?vue&type=template&id=383104d6&scoped=true"
import script from "./myLeaveEdit.vue?vue&type=script&lang=js"
export * from "./myLeaveEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383104d6",
  null
  
)

export default component.exports